import React, { Component } from "react";
import parse from "html-react-parser";
import PropTypes from 'prop-types';

class ServerErrorShowModal extends Component {

    handleRetryButton() {
        return (
            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.props.handleMissingParam}>Try Again</button>
        )
    };

    renderFooterButton() {
        if (this.props.isParamMissing) {
            return this.handleRetryButton();
        }
        if (!this.props.obStatusRecived) {
            return this.props.serverErrorRedirection();
        }
        if (this.props.obStatusRecived && this.props.obStatus === 'failure') {
            return this.props.redirectionBasedOnOB();
        }
        return null;
    };
    
    render() {
        const {
            modalId = "serverErrorShowModel",
            logoSrc = "images/modal-logo.svg",
            serverErrorMessage = "",            
        } = this.props;

        return (
            <dialog className="modal fade model-error" id={modalId} tabIndex="-1" data-keyboard="false" data-backdrop="static" aria-labelledby={`${modalId}Label`} aria-hidden="true">
                <div className="modal-dialog" >
                    <div className="modal-content">
                        <div className="modal-header">
                        </div>
                        <div className="modal-body">
                            <div className="logo">
                                <img src={logoSrc} alt="logo" className="img-fluid" />
                            </div>
                            {/* Added the margin left and right spacing to message displayed in popup */}
                            <p className="text-center mt-4 mx-3">{parse(serverErrorMessage)}</p>
                        </div>
                        <div className="modal-footer mb-4">
                            <div className="modal-footer mb-4">
                                {this.renderFooterButton()}
                            </div>
                        </div>
                    </div>
                </div>
            </dialog>
        );
    }
}
ServerErrorShowModal.propTypes = {
    modalId: PropTypes.string,
    logoSrc: PropTypes.string,
    serverErrorMessage: PropTypes.string,
    obStatusRecived: PropTypes.bool,
    obStatus: PropTypes.string,
    serverErrorRedirection: PropTypes.func,
    redirectionBasedOnOB: PropTypes.func
}
export default ServerErrorShowModal;
